
  import { defineComponent } from 'vue';
  import { AppButton, AppTrapezoid } from '@/components';
  import PageNotFoundIcon from './PageNotFoundIcon.vue';

  export default defineComponent({
    name: 'PageNotFound',

    components: {
      AppButton,
      AppTrapezoid,
      PageNotFoundIcon,
    },

    data() {
      return {
        canGoBack: false,
      };
    },

    created() {
      this.updateCanGoBackStatus();
    },

    methods: {
      updateCanGoBackStatus(): void {
        const historyStateBackPath: string | null = window.history.state.back;
        const referrerHost: string | undefined = document.referrer.split('/')[2];
        const currentHost: string = window.location.host;

        this.canGoBack = historyStateBackPath !== null || referrerHost === currentHost;
      },

      async goBack(): Promise<void> {
        if (this.canGoBack) {
          this.$router.back();
        } else {
          await this.goToDashboard();
        }
      },

      async goToDashboard(): Promise<void> {
        await this.$router.replace(this.dashboardRoute);
      },
    },
  });
